<template>
  <!-- <div style="background-color: #fff; padding: 20px 20px"> -->
  <!-- 标题区 -->
  <!-- <div class="my-3 text-center">
      <h2>用户登录</h2>
    </div> -->
  <!-- 输入区 -->
  <div>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="60px">
      <el-form-item label="帐号" prop="name" class="el-form-item">
        <el-input v-model="ruleForm.name" placeholder="请输入帐号" prefix-icon="el-icon-user" />
      </el-form-item>
      <el-form-item label="密码" prop="pass">
        <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码"
          prefix-icon="el-icon-lock" :show-password="showPassword" @focus="passwordFocus" />
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <div class="d-flex jc-start" style="text-align: left">
          <el-input v-model="ruleForm.code" autocomplete="off" placeholder="验证码" style="width: 63%"
            prefix-icon="el-icon-circle-check" @keyup.native="upper" @keyup.enter.native="submitForm"
            :disabled="isSubmit">
          </el-input>
          <div class="ml-1 mt-1 login-code">
            <img width="100" height="35" :src="codeUrl" @click="getCodeImageBase64" class="login-code-img" />
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="save">
        <div class="d-flex ai-center">
          <el-switch style="display: block" v-model="ruleForm.save" active-color="#13ce66" inactive-color="#eee"
            active-value="1" inactive-value="0" />
          <div class="ml-2">
            {{ ruleForm.save == "1" ? "保存登录信息" : "不保存登录信息" }}
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <div style="text-align: center">
          <el-button type="primary" @click="submitForm">
            登录
          </el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "Login",
  mounted() {
    // 绑定监听事件
    //window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    // 销毁事件
    //window.removeEventListener("keydown", this.keyDown, false);
  },
  created() {
    // 设置网页标题
    //this.pstApi.setWindowTitle();
    document.title = "舆情管理系统";
    //取用户登录信息
    var userdata = this.pstApi.getUserData();
    if (userdata != null) {
      //登录数据不为空则进入欢迎页面
      this.$router.push({ name: "MainFrame" });
    } else {
      let pstuserdata = this.$store.state.userdata;
      if (pstuserdata) {
        this.ruleForm = JSON.parse(pstuserdata);
      }
      //进入登录界面，并获取验证码图片
      this.getCodeImageBase64();
      //this.setBBFlag(); //要在mounted()中运行才行
    }
    this.isSubmit = false;
  },
  data() {
    var checkName = (rule, value, callback) => {
      if (value == "") {
        return callback(new Error("用户名不能为空"));
      }

      setTimeout(() => {
        var isPhone =
          /^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(
            value
          );
        var isEMail =
          /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(
            value
          );
        var isIdcode =
          /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/.test(
            value
          );

        if (!isPhone && !isEMail && !isIdcode) {
          callback(new Error("请输入手机号码"));
        }
        callback();
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      callback();
    };
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      }
      callback();
    };
    return {
      isSubmit: false,
      ruleForm: {
        name: "",
        pass: "",
        code: "",
        save: "0",
      },
      rules: {
        name: [{ validator: checkName, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      codeUrl: "",
      showPassword: false
    };
  },
  methods: {
    //获得焦点
    passwordFocus() {
      if (this.showPassword == false) {
        this.showPassword = true
        this.ruleForm.pass = ""
      }
    },
    //内容变化
    // passwordHandle(value) {
    //   if (this.showPassword == false) {
    //     this.showPassword = true
    //     this.ruleForm.pass = value
    //   }
    // },
    // 点击回车键登录
    keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode === 13) {
        this.submitForm(); // 定义的登录方法
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    upper() {
      if (this.ruleForm.code) {
        this.ruleForm.code = this.ruleForm.code.toUpperCase();
      }
    },
    //获取验证码图片
    getCodeImageBase64() {
      this.ruleForm.code = "";
      this.userApi
        .getCodeImageBase64()
        .then((res) => {
          this.codeUrl = res.data;
        })
        .catch(() => {
          console.log("验证码读取失败");
        });
    },
    submitForm() {
      if (this.isSubmit) return;
      this.isSubmit = true;
      let name = this.ruleForm.name;
      let pass = this.ruleForm.pass;
      let code = this.ruleForm.code;
      //检测用户名
      if (!this.Common.checkUserName(name)) {
        this.$toast("用户名空或格式错误");
        this.isSubmit = false;
        return;
      }

      //检测密码
      if (!this.Common.checkPassword(pass)) {
        this.$toast("密码为空");
        this.isSubmit = false;
        return;
      }
      //检测密码
      if (!this.Common.checkCaptcha(code)) {
        this.$toast("验证码错误");
        this.isSubmit = false;
        return;
      }

      //调用userapi 登录函数
      this.userApi
        .userLogin(name, pass, code)
        .then(async (resp) => {
          var userdata = resp.data;
          var token = resp.data.token;
          window.sessionStorage.setItem("token", token);
          //console.log(resp.data)
          //登录成功，获取用户角色
          var res = await this.pstApi
            .getRoles()
            .then((resp) => {
              this.isSubmit = false;
              //
              //console.log("hasRoles:", resp.data);
              userdata.hasRoles = resp.data;
              window.sessionStorage.setItem(
                "UserData",
                JSON.stringify(userdata)
              );

              //console.log(userdata)

              if (userdata.passwordVerifyPass == false) {
                //console.log('setpassword')
                //return;
                this.$toast("密码过于简单，为了安全，你需要修改密码！");
                //this.$router.replace('/new-route');
                this.$router.replace({ name: "SetPassword" });
              } else {
                if (this.ruleForm.save == "1") {
                  this.$store.commit(
                    "saveUserData",
                    JSON.stringify(this.ruleForm)
                  );
                  //this.$toast("已保存登录信息");
                } else {
                  this.$store.commit("saveUserData", "");
                  //this.$toast("已删除登录信息");
                }
                this.$router.replace({ name: "MainFrame" });
              }
            })
            .catch(() => {
              var message = "用户角色获取失败";
              this.$toast(message);
              //重取二维码
              this.getCodeImageBase64();
              this.isSubmit = false;
            });
        })
        .catch((err) => {
          var message = err.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }

          this.$toast(message);
          //重取二维码
          this.getCodeImageBase64();
          this.isSubmit = false;
        });
      //this.isSubmit = false;
    },
  },
};
</script>

<style lang='less' scoped>
.foot-text {
  height: 25px;
}
</style>
